import React, { useEffect, useState, Fragment } from "react";
import axios from "axios";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Cookies from "js-cookie";
import Moment from "react-moment";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Defaultimg from "../../assets/Frame.png";
import Stats from "../Tabs/Stats";
import PleaseWait from "../../Components/Reuseable/PleaseWait";
import arrow1 from "../../assets/image 13 (Traced).png";
import { useDispatch, useSelector } from "react-redux";
import { fetchTrainerHistory } from "../../redux/getReducer/getTrainerHistory";
import { fetchSingletrainer, STATUSES } from "../../redux/getReducer/getSingleTrainer";
import { OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import HorseModal from "./HorseModal";
import { useTranslation } from "react-i18next";
import TrainerEntries from "../Tabs/TrainerEntries";
import VideoFrame from "./VideoFrame";
import JockeyDetail from "./JockeyModal";
import RaceModal from "./RaceModal";
import Lottie from "lottie-react";
import Animate from "../../assets/loader.json";
import Pagination from "../../pages/Pagination";
import { IoIosArrowDropdownCircle, IoMdPlay } from "react-icons/io";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import ScrollContainer from "react-indiana-drag-scroll";


import { getBaseUrl } from "../../service/apiUrl";
import { truncateRaceType, toTitleCase } from "../../service/stringUtils";
// import "./TrainerDetailNew.css"; 

const TrainerDetail = (data) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cookiedata = Cookies.get("i18next");
  const token = Cookies.get("token");

  const trainerid = data.data.TrainerOnRaceData1
    ? data.data.TrainerOnRaceData1._id
    : data.data._id
    ? data.data._id
    : data.data;

  const { data: TrainerHistory } = useSelector((state) => state.TrainerHistory);
  const { data: singletrainer, status } = useSelector((state) => state.singletrainer);

  // --- MODAL STATES ---
  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();
  const handleCloses = () => setShows(false);
  const handleShows = async (data) => { setmodaldatas(data); await setShows(true); };

  const handleShowRace = (rId) => { 
    if (rId) navigate("/race-detail?" + rId);
  };

  const handleShowJockey = (data) => { 
    const jId = data?._id || data;
    if (jId) navigate("/jockey-detail?" + jId);
  };

  const [ShowHorse, setShowHorse] = useState(false);
  const [modaldatasHorse, setmodaldatasHorse] = useState();
  const handleHorseCloses = () => setShowHorse(false);
  const handleShowHorse = (data) => {
    const id = data?._id || data;
    if (id) navigate("/horse-detail?" + id);
  };

  // Pagination Logic Preserved
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(11);
  let totalcountdata = TrainerHistory ? TrainerHistory?.length : "";
  const totalpagesdata = Math.ceil(totalcountdata / postsPerPage);
  const firstPageIndex = (currentPage - 1) * postsPerPage;
  const lastPageIndex = firstPageIndex + postsPerPage;
  const SliceData = TrainerHistory ? TrainerHistory.slice(firstPageIndex, lastPageIndex) : [];
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    dispatch(fetchTrainerHistory({ trainerid }));
    dispatch(fetchSingletrainer({ trainerid }));
  }, [dispatch, trainerid]);

  const handleUnTrack = async (Id) => {
    try {
      await axios.post(`${getBaseUrl()}/UnTrackTrainer`, { Trainer: Id }, { headers: { Authorization: token, "x-xsrf-token": token } });
      toast("Trainer Has Been UnTracked");
      navigate("/tracker/#Trainerprofile");
    } catch (error) { toast(error.response.data.message); }
  };

  const handleTrack = async (Id) => {
    try {
      await axios.post(`${getBaseUrl()}/tracktrainer`, { Trainer: Id }, { headers: { Authorization: token, "x-xsrf-token": token } });
      navigate("/tracker/#Trainerprofile");
    } catch (error) {
      const err = error.response.data.message;
      if (err === "Json Web Token is invalid") { toast.error("Please Login to Access This Resource"); navigate("/login"); } else { toast.error(err); }
    }
  };

  function calculatePercentage(x, y) { return (x === 0 || y === 0) ? 0 : Math.round((x / y) * 100); }

  function distanceLabel(distance, rank) {
    const d = parseFloat(distance);
    if (d.toFixed(2) > 25) return "Dist";
    if (d.toFixed(2) == 0.05 && rank < 80) return "SHd";
    if (d.toFixed(2) == 0.10 && rank < 80) return "Hd";
    if (d.toFixed(2) == 0.25 && rank < 80) return "Nk";
    if (d.toFixed(2) == 0.01 && rank < 80) return "Ns";
    if (d.toFixed(2) == 0.00 && rank < 80) return rank === 1 ? 0 : "Dh";
    return distance;
  }

  return (
    <div className="new-tranier-modal-master-wrapper">
      {status === "loading" ? (
        <Lottie animationData={Animate} loop={true} style={{width: 150, margin: 'auto'}} />
      ) : (
        <>
          {/* --- TOP SECTION: Profile Card --- */}
          <div className="new-tranier-modal-profile-header">
            <div className="new-tranier-modal-left-side">
              <div className="new-tranier-modal-img-box">
                <img src={singletrainer.image || Defaultimg} alt="Trainer" />
              </div>
              <div className="new-tranier-modal-info-content">
                {/* Column 1: Identity */}
                <div className="new-tranier-modal-main-details">
                  <h3 className="new-tranier-modal-name">{cookiedata === "en" ? singletrainer?.NameEn : singletrainer?.NameAr}</h3>
                  <p className="new-tranier-modal-stats-row">
                    {singletrainer?.TotalCount || "0"} 
                    ({singletrainer?.TrainerFirstRanking || "0"}-{singletrainer?.TrainerSecondRanking || "0"}-{singletrainer?.TrainerThirdRanking || "0"})
                  </p>
                </div>
              </div>
            </div>
            <div className="new-tranier-modal-right-side">
              {singletrainer?.track ? (
                <button className="new-tranier-modal-btn-untrack" onClick={() => handleUnTrack(singletrainer._id)}>{t("Untrack")}</button>
              ) : (
                <button className="new-tranier-modal-btn-track" onClick={() => handleTrack(singletrainer._id)}>{t("Track")}</button>
              )}
            </div>
          </div>

          {/* --- MIDDLE SECTION: Lifetime Record Grid --- */}
          <div className="new-tranier-modal-middle-grid">
              <div className="new-tranier-modal-grid-thead">
                  <div>{t("Lifetime Record")}</div><div>{t("Runs")}</div><div>{t("Wins")}</div><div>{t("2nd")}</div><div>{t("3rd")}</div><div>{t("4th")}</div><div>{t("5th")}</div><div>{t("Winnings")}</div><div>{t("Earnings")}</div>
              </div>
              <div className="new-tranier-modal-grid-tbody">
                  <div className="new-tranier-modal-grid-row">
                      <div className="new-bold">{t("Turf")}</div><div style={{ textAlign: 'center' }}>{singletrainer.TurfCount}</div><div style={{ textAlign: 'center' }}>{singletrainer.TurfWins || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.Turfsecond || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.Turfthird || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.Turffourth || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.Turffifth || 0}</div><div style={{ textAlign: 'center' }}>{calculatePercentage((singletrainer.Turfsecond || 0) + (singletrainer.TurfWins || 0) + (singletrainer.Turfthird || 0), singletrainer.TurfCount)}%</div><div style={{ textAlign: 'center' }}>{Number(singletrainer.TurfEarnings || 0).toLocaleString()} {t("AED")}</div>
                  </div>
                  <div className="new-tranier-modal-grid-row">
                      <div className="new-bold">{t("Dirt")}</div><div style={{ textAlign: 'center' }}>{singletrainer.DirtCount}</div><div style={{ textAlign: 'center' }}>{singletrainer.DirtWins || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.Dirtsecond || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.Dirtthird || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.Dirtfourth || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.Dirtfifth || 0}</div><div style={{ textAlign: 'center' }}>{calculatePercentage((singletrainer.Dirtsecond || 0) + (singletrainer.DirtWins || 0) + (singletrainer.Dirtthird || 0), singletrainer.DirtCount)}%</div><div style={{ textAlign: 'center' }}>{Number(singletrainer.DirtEarnings || 0).toLocaleString()} {t("AED")}</div>
                  </div>
                  <div className="new-tranier-modal-grid-row">
                      <div className="new-bold">{t("All Weather")}</div><div style={{ textAlign: 'center' }}>{singletrainer.AllWeatherCount}</div><div style={{ textAlign: 'center' }}>{singletrainer.AllWeatherWins || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.AllWeathersecond || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.AllWeatherthird || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.AllWeatherfourth || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.AllWeatherfifth || 0}</div><div style={{ textAlign: 'center' }}>{calculatePercentage((singletrainer.AllWeathersecond || 0) + (singletrainer.AllWeatherWins || 0) + (singletrainer.AllWeatherthird || 0), singletrainer.AllWeatherCount)}%</div><div style={{ textAlign: 'center' }}>{Number(singletrainer.AllWeatherEarnings || 0).toLocaleString()} {t("AED")}</div>
                  </div>
                  <div className="new-tranier-modal-grid-row new-tranier-modal-total-row">
                      <div className="new-bold">{t("Total")}</div><div style={{ textAlign: 'center' }}>{singletrainer.TotalCount}</div><div style={{ textAlign: 'center' }}>{singletrainer.TotalWins || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.Totalsecond || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.Totalthird || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.Totalfourth || 0}</div><div style={{ textAlign: 'center' }}>{singletrainer.Totalfifth || 0}</div><div style={{ textAlign: 'center' }}>{calculatePercentage((singletrainer.Totalsecond || 0) + (singletrainer.TotalWins || 0) + (singletrainer.Totalthird || 0), singletrainer.TotalCount)}%</div><div style={{ textAlign: 'center' }}>{Number(singletrainer.TotalEarnings || 0).toLocaleString()} {t("AED")}</div>
                  </div>
              </div>
          </div>

          {/* --- BOTTOM SECTION: Tab Navigation --- */}
          <div className="new-tranier-modal-tabs-container">
            <Tabs id="trainer-tabs" className="new-tranier-modal-styled-tabs mb-4" defaultActiveKey="Form">
                <Tab eventKey="Form" title={t("Form")}>
                   <div className="new-tranier-modal-tab-content">
                      <ScrollContainer className="new-tranier-modal-scroll-box">
                         <div className="new-tranier-modal-16col-table">
                            <div className="new-tranier-modal-thead-16">
                                <div>{t("Date")}</div><div>{t("Crs")}</div><div>{t("Horse Name")}</div><div>{t("Dist")}</div><div>{t("RT")}</div><div>{t("Time")}</div><div>{t("Jockey")}</div><div>{t("Wgt")}</div><div>{t("Speed")}</div><div>{t("FP")}</div><div>{t("Len")}</div><div>{t("RN")}</div><div>{t("BtBy")}</div><div>{t("W Kgs")}</div><div>{t("Draw")}</div><div>{t("OR")}</div><div>{t("Link")}</div>
                            </div>
                            <div className="new-tranier-modal-tbody-16">
                               {(!SliceData || SliceData.length === 0) ? <div className="text-center py-4"><PleaseWait /></div> : SliceData.map((item, idx) => {
                                   const ground = item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                                   const rowBg = ground === "Turf" ? "#d4edda" : ground === "Dirt" ? "#f2e6d9" : "#f1f5f9";
                                   return (
                                     <div key={idx} className="new-tranier-modal-row-16" style={{ backgroundColor: rowBg, color: '#343433' }}>
                                        <div onClick={() => handleShowRace(item.RaceID)} className="new-tranier-modal-link-white"><Moment format="DD/MM/YYYY">{item.RaceResultData?.Day}</Moment></div>
                                        <div>
                                          {cookiedata === "en" ? (item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceCourseData?.AbbrevEn) : (item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceCourseData?.AbbrevAr)} 
                                          ({cookiedata === "en" ? ground?.charAt(0) : item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameAr?.charAt(0)})
                                        </div>
                                        <div className="new-tranier-modal-link-white" onClick={() => handleShowHorse(item?.HorseIDData?._id)}>
                                          {cookiedata === "en" ? toTitleCase(item.HorseIDData?.NameEn || "-") : (item.HorseIDData?.NameAr || "-")}
                                        </div>
                                        <div>{item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.TrackLength}</div>
                                        <div className="new-tranier-modal-truncate">{cookiedata === "en" ? toTitleCase(truncateRaceType(item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceTypeModelData?.NameEn)) : item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceTypeModelData?.NameAr}</div>
                                        <div>{item.RaceTime}</div>
                                        <div onClick={() => handleShowJockey(item.JockeyOnRaceDataResult?._id)} className="new-tranier-modal-link-white">{cookiedata === "en" ? toTitleCase(item.JockeyOnRaceDataResult?.ShortNameEn) : item.JockeyOnRaceDataResult?.ShortNameAr}</div>
                                        <div>{item.RaceResultData?.RacehorsesData?.[0]?.JockeyRaceWeight}</div>
                                        <div>{typeof item.Speed === "number" ? item.Speed.toFixed(2) : "-"}</div>
                                        <div>{cookiedata === "en" ? toTitleCase(item.FinalPositionDataHorse?.NameEn) : item.FinalPositionDataHorse?.NameAr}</div>
                                        <div>{distanceLabel(item.Distance, item.FinalPositionDataHorse?.Rank)}</div>
                                        <div>{item.Runners}</div>
                                        {(() => {
                                          const rank = item?.FinalPositionDataHorse?.Rank;
                                          const targetHorse = rank === 1
                                            ? (item?.RunnerUpData || item?.BeatenByData || null)
                                            : (item?.WinnerData || item?.BeatenByData || null);
                                          const targetName = targetHorse
                                            ? (cookiedata === "en" ? toTitleCase(targetHorse.NameEn || "") : (targetHorse.NameAr || targetHorse.NameEn || "-"))
                                            : (cookiedata === "en"
                                                ? toTitleCase(item?.HorseIDData?.HorseBeatenByEnglishName || "")
                                                : (item?.HorseIDData?.HorseBeatenByArabicName || item?.HorseIDData?.HorseBeatenByEnglishName || "-"));
                                          const targetId = targetHorse?._id || item?.BeatenByData?._id;
                                          const targetWeight = targetHorse?.WinningHorseJockeyWeight ?? item?.BeatenByData?.WinningHorseJockeyWeight ?? item?.HorseIDData?.BeatenByJockeyWeight ?? 0;

                                          return (
                                            <>
                                              <div
                                                className={`new-tranier-modal-truncate ${targetId ? "new-tranier-modal-link-white" : ""}`}
                                                title={targetName || ""}
                                                onClick={() => targetId && handleShowHorse(targetId)}
                                                style={{ cursor: targetId ? "pointer" : "default" }}
                                              >
                                                {targetName || "-"}
                                              </div>
                                              <div>{targetWeight}</div>
                                            </>
                                          );
                                        })()}
                                        <div>{item.RaceResultData?.RacehorsesData?.[0]?.HorseNo || "-"}</div>
                                        <div>{item.Rating || 0}</div>
                                        <div onClick={() => handleShows(item.VideoLink)} className="new-tranier-modal-mini-play"><IoMdPlay /></div>
                                     </div>
                                   );
                               })}
                            </div>
                         </div>
                      </ScrollContainer>
                      <div className="new-tranier-modal-pagination-wrapper">
                         <Pagination postsPerPage={postsPerPage} totalPosts={totalcountdata} paginate={paginate} currentPage={currentPage} TotalPages={totalpagesdata} />
                      </div>
                   </div>
                </Tab>
                <Tab eventKey="Entries" title={t("Entries")}><TrainerEntries id={trainerid} /></Tab>
                <Tab eventKey="Stats" title={t("Stats")}><div className="RaceDetailCard"><Stats id={trainerid} /></div></Tab>
            </Tabs>
          </div>
        </>
      )}

      {/* --- ALL MODALS PRESERVED --- */}
      <Modal show={shows} onHide={handleCloses} size="lg" centered><Modal.Body><VideoFrame data={modaldatas} /></Modal.Body></Modal>
    </div>
  );
};

export default TrainerDetail;